export default __webpack_public_path__ + "static/drinking_fountain_b.13f4262bf2ec706274c40aa87fdd0fd0.png";